import { Box, Button, styled, Typography } from '@mui/material'
import { ForwardIcon } from '$common/icons'
import { ReplyIcon } from '$common/icons/reply'
import { t } from '$i18n'

const Root = styled(Box)`
  height: 54px;
  padding: 0 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  z-index: 1;
`
const StyledButton = styled(Button)` 
  height: 40px;
  /* @noflip */
  border-radius: 8px; 
  .MuiButton-startIcon {
    > svg {
      font-size: 24px;
    }
  }
  .MuiButton-endIcon {
    margin-right: 8px;
    margin-left: 0;
    > svg {
      font-size: 24px;
    }
  },
`

export function SelectBar({
  onReply,
  onForward,
  arePermissionsStale,
}: {
  onForward: (() => Promise<void>) | null
  onReply: (() => void) | null
  arePermissionsStale?: boolean
}) {
  return (
    <Root dir="rtl">
      {onForward && (
        <StyledButton
          disabled={arePermissionsStale}
          startIcon={<ForwardIcon sx={{ color: 'secondary.main' }} />}
          onClick={onForward}
        >
          <Typography color="secondary.main" variant="subtitle3">
            {t('chat.forward')}
          </Typography>
        </StyledButton>
      )}
      {onReply && (
        <StyledButton
          disabled={arePermissionsStale}
          endIcon={<ReplyIcon />}
          onClick={onReply}
        >
          <Typography color="secondary.main" variant="subtitle3">
            {t('contextMenu.reply')}
          </Typography>
        </StyledButton>
      )}
    </Root>
  )
}
